import userService from '@/services/userService'
import { Ability } from '@casl/ability'

const state = { 
    identity: {},
    last_updated: null

}

const getters = {
    getUsername() {
        return state.identity.username
    },
    ability() {
        return new Ability(state.identity.casl)
    },
}

const actions = {
    getUser ({ commit }) {
        userService.getUser()
        .then( user => {
          commit('setUser', user)
        })
        .then(
            this.$ability.update(this.$store.state.user.identity.casl)
        )
      },
    clearUser ({ commit }) {
       commit('clearUser')
    },
    setLastUpdated ({commit}, last_updated) {
        commit('setLastUpdated', last_updated)
    }
}

const mutations = {
    setUser(state, user) { 
        state.identity = user
    },
    clearUser(state) {
        state.identity = {}   
    },
    setLastUpdated(state, last_updated) {
        state.last_updated = last_updated
    }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};





